import Maps from "./ClassMaps"


const maps = document.querySelectorAll('.map')


!!maps &&
maps.forEach( (map) => {
    let ID = map.getAttribute('id')
    let lng = map.getAttribute('data-long')
    let lat = map.getAttribute('data-lat')
    let zoom = map.getAttribute('data-zoom')
    let loader = map.closest('.wrapper_map').querySelector('.loader')

    let filtersInput = document.querySelectorAll('.filter__select-wrapper [type=checkbox]:not(.is-parent)')
    let filtersInputParent = document.querySelectorAll('.filter__select-wrapper .maps-term [type=checkbox].is-parent')
    let filtersSVG = document.querySelectorAll('.filter__select-wrapper .maps-term .filter__input-svg')

    /*Keyword Input*/
    let $keywordsFilter = document.getElementById('mapKeywordsFilter')
    let $keywordsController = document.getElementById('mapKeywordsController')
    let $container = $keywordsFilter ? $keywordsFilter.closest('.filter__select-wrapper') : ''

    /*From URL*/
    let urlQuery = window.location.search
    let params = new URLSearchParams(urlQuery)
    let urlQueryPost = params.get("maps")
    let urlQueryTerm = params.get("maps_category")
    let urlQueryPreview = params.get("preview")

    let resetBtn = document.getElementById('resetMapSelection')

    !!filtersSVG &&
    filtersSVG.forEach(function (filterSVG) {
        filterSVG.addEventListener('click', function () {
            filterSVG.closest('.select-box').classList.toggle('is-closed')
            filterSVG.closest('.select-box').classList.toggle('is-open')
        })
    })

    console.log(lng + ' - ' + lat + ' - ' + zoom + ' - ' + loader)
    // Init the Maps Class
    let Map = new Maps(ID, lng, lat, zoom, loader)
    //console.log(Map)
    // Init the PostsQuery Class
    new PostsQuery()

    // Init the Map
    Map.init

    /*From data-attributes*/
    let blocMap = map.closest('.bloc-map')

    if (!!blocMap) {
        let ids = blocMap.getAttribute('data-ids')
        let term = blocMap.getAttribute('data-term')
        Map.mapParams.includeAllMarker = true

        if (!!ids) {
            let idsArray = ids.split(',')
            Map.addMarkers('', '', idsArray)
        }

        if (!!term) {
            Map.addMarkers([Number(term)])
        }
    }

    if (urlQueryPreview === 'true') {
        Map.mapParams.isPreview = true
    }

    if (urlQueryPost !== null) {
        Map.mapParams.includeAllMarker = true
        Map.addMarkers('', '', [urlQueryPost])
    }

    if (urlQueryTerm !== null) {
        Map.mapParams.includeAllMarker = false
        let filtersInputAll = document.querySelectorAll('.filter__select-wrapper [type=checkbox]')
        !!filtersInputAll &&
        filtersInputAll.forEach(function (filterBtnAll) {
            if (filterBtnAll.getAttribute('data-id') === urlQueryTerm) {
                filterBtnAll.checked = true
                resetBtn.classList.remove('disable')
            }
        })
        Map.addMarkers([Number(urlQueryTerm)], '', '')
    }

    /***
     * This listener is used to
     * 1. Display marker from the value
     * 2. Toggle the $keywordsController to search or reset the input
     * ***/
    if (!!$keywordsFilter) {
        $keywordsFilter.addEventListener('input', () => {

            if ($keywordsFilter.value.length > 0) {
                $keywordsFilter.classList.add('selected')
            }
        })

        $keywordsFilter.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                $keywordsController.dispatchEvent(new Event('click'))
            }
        });

        $keywordsController.addEventListener('click', () => {
            if ($keywordsController.classList.contains('reset-filter')) {
                Map.resetKeywordsMarkers()
                $keywordsFilter.value = ''
                $keywordsController.classList.remove('reset-filter')
                $container.classList.remove('no-result')
            } else if ($keywordsFilter.value.length > 0) {
                Map.addMarkers('', $keywordsFilter.value)
            }

        })
    }

    // Event listener on input terms
    !!filtersInput &&
    filtersInput.forEach(function (filterBtn) {
        filterBtn.addEventListener('change', function () {
            let termsID = [Number(this.getAttribute('data-id'))]

            if (!this.checked) {
                Map.removeMarkers(termsID)
            } else {
                Map.addMarkers(termsID)
            }

            let $checkboxChecked = document.querySelectorAll('.filter__select-wrapper [type=checkbox]:checked')

            if($checkboxChecked.length > 0){
                resetBtn.classList.remove('disable')
            }
            else{
                resetBtn.classList.add('disable')
            }
        })
    })

    !!filtersInputParent &&
    filtersInputParent.forEach(function (filterBtn) {
        filterBtn.addEventListener('change', function () {
            let termsID = [Number(this.getAttribute('data-id'))]
            let filtersInputChildren = this.closest('.select-box').querySelectorAll('.filter__term-container [type=checkbox]')

            if (!this.checked) {
                filtersInputChildren.forEach(function (filterInputChildren) {
                    if (filterInputChildren.checked === true) {
                        termsID.push(Number(filterInputChildren.getAttribute('data-id')))
                    }
                    filterInputChildren.checked = false
                })
                filterBtn.closest('.select-box').classList.remove('selected')
                Map.removeMarkers(termsID)
            } else {
                filtersInputChildren.forEach(function (filterInputChildren) {
                    if (filterInputChildren.checked === false) {
                        termsID.push(Number(filterInputChildren.getAttribute('data-id')))
                    }
                    filterInputChildren.checked = true
                })
                filterBtn.closest('.select-box').classList.add('selected')
                Map.addMarkers(termsID)
            }

            let $checkboxChecked = document.querySelectorAll('.filter__select-wrapper [type=checkbox]:checked')

            if($checkboxChecked.length > 0){
                resetBtn.classList.remove('disable')
            }
            else{
                resetBtn.classList.add('disable')
            }
        })
    })

    !!resetBtn &&
    resetBtn.addEventListener('click', function () {
        let wrappersSelected = document.querySelectorAll('.filter__select-wrapper.selected')
        let inputsChecked = document.querySelectorAll('.filter__select-wrapper [type=checkbox]:checked')

        wrappersSelected.forEach(function (wrapperSelected) {
            wrapperSelected.classList.remove('selected')
        })

        inputsChecked.forEach(function (inputChecked) {
            inputChecked.checked = false
        })

        Map.resetTermsMarkers()
        resetBtn.classList.add('disable')
    })

    ID++

    function requireAll(r) {
        r.keys().forEach(r);
    }

    requireAll(require.context('../../', true, /\.(png|jpe?g|gif|svg)$/));
})


